import { apiURLNew, callAPI } from 'api/main';

import { middlewareUser } from './middleware';

export default async (professionalId: string): Promise<IUser | null> => {
  try {
    const res = await callAPI({
      url: `${apiURLNew}/user/private/people/peoples/v1/${professionalId}`,
      method: 'GET',
      isLegacy: false,
      needToken: true,
    });

    const { data } = res.request;

    if (data) {
      return middlewareUser(data);
    }

    return null;
  } catch (ex) {
    return null;
  }
};
